import { SupportedThemes } from '../types';

declare const THEME: SupportedThemes;

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace globalThis {
    // eslint-disable-next-line no-var,no-shadow
    var THEME: SupportedThemes;
  }
}

/**
 * @param {function} resolver Resolver function. It receives current THEME as parameter.
 * @param {string} defaultThemeName
 */
const resolveByTheme:
  <T>(resolver: (theme: SupportedThemes) =>
    T, defaultThemeName?: SupportedThemes) => T = ((resolver, defaultThemeName = 'currys') => {
      if (typeof THEME === 'undefined') {
        global.THEME = defaultThemeName;
      }
      return resolver(THEME);
    });

export default resolveByTheme;
